'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('myaccount', {
      url: '/account/myaccount',
      template: '<myaccount></myaccount>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/account/myaccount/myaccount.routes.js